import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconShare = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" }),
		/* @__PURE__ */ _jsx("polyline", { points: "16 6 12 2 8 6" }),
		/* @__PURE__ */ _jsx("line", {
			x1: 12,
			y1: 2,
			x2: 12,
			y2: 15
		})
	]
});
export default SvgIconShare;
